(ns manage.ad-variant.creation.template.db
  (:require [common.url-template :as url-tpl]
            [manage.ad-variant.creation.product-strategy.core :as product-strategy.core]
            [manage.ad-variant.data :as data]
            [re-frame.core :as rf]))

(rf/reg-event-fx
  :ad-variant-creation/set-state
  (fn [{:keys [db]} [_ op value]]
    {:db (assoc-in db [:ad-variant-creation op] value)}))

(rf/reg-event-fx
  :ad-variant-creation/update-ad-types-selection
  (fn [{:keys [db]} [_ value selected]]
    (let [ad-types (or (-> db :ad-variant-creation :ad-types) #{})]
      {:db (assoc-in db [:ad-variant-creation :ad-types]
                     (if selected
                       (conj ad-types value)
                       (disj ad-types value)))})))

(rf/reg-event-fx
  :ad-variant-creation/set-templates
  (fn [{:keys [db]} [_ value]]
    {:db (assoc-in db [:ad-variant-creation :templates] value)}))

(rf/reg-event-fx
  :ad-variant-creation/clear
  (fn [_ [_ _]]
    {:fx [[:dispatch [:ad-variant-creation/set-state :ad-types nil]]
          [:dispatch [:ad-variant-creation/set-templates nil]]
          [:dispatch [(keyword :table.after-effects-templates :deselect-all-rows)]]
          [:dispatch [(keyword :table.html-templates :deselect-all-rows)]]]}))

(rf/reg-sub
  :ad-variant-creation/state
  (fn [db [_ op]]
    (get-in db [:ad-variant-creation op])))

(rf/reg-sub
  :ad-variant-creation/ad-types
  :<- [:ad-variant-creation/state :ad-types]
  (fn [ad-types] ad-types))

(rf/reg-sub
  :ad-variant-creation/templates
  :<- [:ad-variant-creation/state :templates]
  (fn [templates] templates))

(rf/reg-sub
  :ad-variant-creation/template
  :<- [:ad-variant-creation/templates]
  (fn [templates] (first templates)))

(defn to-ad-builder-spec
  [ad-type name template-revision {:keys [placeholder-name product-strategy-id]}]
  {:name name
   :urn (-> (get data/ad-types ad-type) :ad-builder-urn)
   :ad-formats [(cond-> {:template-type (:templateType template-revision)
                         :width (:width template-revision)
                         :height (:height template-revision)
                         :template-revision-id (:id template-revision)}
                  product-strategy-id
                  (assoc-in [:dynamic-content :product-strategy]
                            [{:placeholder-name placeholder-name
                              :product-strategy-id product-strategy-id}]))]})

(defn ad-types-by-channel [channel]
  ;; these is used for single-step ad-builders creation
  ;; when ad-formats is not selected manually.
  (case channel
    "display" ["display-html"]
    "video" ["vast-linear"]
    "ctv" ["vast-linear"]
    nil))

(rf/reg-event-fx :ad-variant-creation/create-ad-builder
  ;; Is product-strategy-id still needed?
  (fn [{:keys [db]} [_ product-strategy-id current-channel]]
    (let [ad-types (or (-> db :ad-variant-creation :ad-types)
                       (ad-types-by-channel current-channel))
          templates (-> db :ad-variant-creation :templates)
          payload {:adBuilders
                   (->> templates
                        (mapv (fn [template]
                                ;; Is this still needed?
                                (let [{:keys [placeholder-name]}
                                      (product-strategy.core/ad-format->product-collection-placeholder
                                       {:current-revision (:latestRevision template)})]
                                  (mapv #(to-ad-builder-spec
                                          %
                                          (:name template)
                                          (:latestRevision template)
                                          (when (and placeholder-name (= "display" current-channel))
                                            {:product-strategy-id product-strategy-id
                                             :placeholder-name placeholder-name}))
                                        ad-types))))
                        flatten)
                   :operation "add"}]
      {:fx [[:dispatch [:loader/open]]
            [:async-flow
             {:id :ad-variant-creation/create-ad-builder-flow
              :first-dispatch [::update-ad-builders payload]
              :rules [{:when :seen?
                       :events ::update-ad-builders-failure
                       :halt? true
                       :dispatch [::create-template-failure]}
                      {:when :seen?
                       :events ::update-ad-builders-success
                       :halt? true
                       :dispatch [::create-ad-builder-success]}]}]]})))

(rf/reg-event-fx
  ::create-ad-builder-success
  []
  (fn [_ _]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :success
                                               :message "Successfully created Ad variant template."}]]
          [:dispatch [:ad-variant-creation/clear]]
          [:dispatch [:modal/close]]]}))

(rf/reg-event-fx
  ::create-template-failure
  (fn []
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :error
                                               :message "Failed to create Ad variant template."}]]]}))

(rf/reg-event-fx
  :ad-variant-creation/delete-ad-builder
  (fn [_ [_ item]]
    (let [payload {:adBuilders [item]
                   :operation "remove"}]
      {:fx [[:dispatch [:loader/open]]
            [:async-flow
             {:id :ad-variant-creation/delete-ad-builder-flow
              :first-dispatch [::update-ad-builders payload]
              :rules [{:when :seen?
                       :events ::update-ad-builders-failure
                       :halt? true
                       :dispatch [::delete-ad-builder-failure]}
                      {:when :seen?
                       :events ::update-ad-builders-success
                       :halt? true
                       :dispatch [::delete-ad-builder-success]}]}]]})))

(rf/reg-event-fx
  ::delete-ad-builder-success
  (fn [_ _]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :success
                                               :message "Ad variant template was deleted."}]]]}))

(rf/reg-event-fx
  ::delete-ad-builder-failure
  (fn []
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :error
                                               :message "Failed to delete Ad variant template."}]]]}))

(rf/reg-event-fx ::update-ad-builders
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ params {:keys [on-success on-failure]
                                                    :or {on-success [::update-ad-builders-success]
                                                         on-failure [::update-ad-builders-failure]}}]]
    {:db (assoc db :ad-variant-creation/update-ad-builders {:state :pending})
     :http
     {:method :patch
      :uri (url-tpl/render :api/adset-ad-builders url-context)
      :params params
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success on-success
      :on-failure on-failure}}))

(rf/reg-event-fx
  ::update-ad-builders-success
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]} _]
    (let [adset-id (:adset-id url-context)]
      {:db (-> db
               (assoc-in [:ad-variant-creation/update-ad-builders] {:state :success}))
       :fx [[:invalidate-queries {:queryKey ["adset" adset-id]}]
            [:invalidate-queries {:queryKey [:ad-builders-upgrade-hints adset-id]}]]})))

(rf/reg-event-db ::update-ad-builders-failure
  (fn [db _]
    (assoc db :ad-variant-creation/update-ad-builders {:state :failure})))

(defn ->ad-formats-payload
  [ad-builders]
  (let [ad-formats-fn (fn [ad-formats]
                        (let [template-revision-id (get-in (first ad-formats) [:latest-revision :id])]
                          [(-> ad-formats
                               first
                               (assoc :template-revision-id template-revision-id)
                               (dissoc :latest-revision :current-revision))]))]
    (map (fn [ad-builder]
           {:id (:id ad-builder)
            :ad-formats (ad-formats-fn (:ad-formats ad-builder))})
         ad-builders)))

(rf/reg-event-fx :ad-variant-creation/update-template-revision
  (fn [_ [_ ad-builders]]
    (let [payload (->ad-formats-payload ad-builders)]
      {:fx [[:dispatch [:loader/open]]
            [:async-flow
             {:id :ad-variant-creation/update-ad-formats-flow
              :first-dispatch [::update-ad-formats payload]
              :rules [{:when :seen?
                       :events ::update-ad-formats-failure
                       :halt? true
                       :dispatch [::update-ad-formats-revisions-failure]}
                      {:when :seen?
                       :events ::update-ad-formats-success
                       :halt? true
                       :dispatch [::update-ad-formats-revisions-success]}]}]]})))

(rf/reg-event-fx
  ::update-ad-formats
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context] :as cofx} [_ params {:keys [on-success on-failure]
                                                    :or {on-success [::update-ad-formats-success]
                                                         on-failure [::update-ad-formats-failure]}}]]
    {:db (assoc db :ad-variant-creation/update-ad-formats {:state :pending})
     :http
     {:method :put
      :uri (url-tpl/render :api/adset-ad-formats url-context)
      :params params
      :headers {:Authorization (:resource.user/token cofx)}
      :on-success on-success
      :on-failure on-failure}}))

(rf/reg-event-fx ::update-ad-formats-success
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context]} _]
    {:db (-> db
             (assoc-in [:ad-variant-creation/update-ad-formats] {:state :success}))
     :fx [[:invalidate-queries {:queryKey ["ad-builders-upgrade-hints" (:adset-id url-context)]}]]}))

(rf/reg-event-db
  ::update-ad-formats-failure
  (fn [db _]
    (assoc db :ad-variant-creation/update-adset-ad-formats {:state :failure})))

(rf/reg-event-fx ::update-ad-formats-revisions-success
  (fn [_ _]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :success
                                               :message "Ad variant template revisions was updated."}]]]}))

(rf/reg-event-fx ::update-ad-formats-revisions-failure
  (fn []
    {:fx [[:dispatch [:loader/close]]
          [:dispatch
           [:response-handler/handle-response {:entity-name "Ad variant template"
                                               :type    :error
                                               :message "Failed to update Ad variant template revision."}]]]}))
